<div *appRoles="[
'Notas.Crear',
'Notas.Modificar',
'Notas.Eliminar'
]">
  @if (action === 'Agregar') {
    <button mat-raised-button color="primary" [disabled]="disabled" name="Modificar">
      <mat-icon>add</mat-icon> Agregar
    </button>
  }
  @if (action === 'Modificar') {
    <button mat-raised-button color="primary" [disabled]="disabled" name="Modificar">
      <mat-icon>save</mat-icon> Guardar
    </button>
  }
  @if (action === 'Eliminar') {
    <button mat-raised-button color="primary" [disabled]="disabled" name="Modificar">
      <mat-icon>delete</mat-icon> Eliminar
    </button>
  }
</div>
